import Model from './Model';

export default class ApplicationAttachment extends Model {
    uploader;
    name;
}



// WEBPACK FOOTER //
// ./src/models/ApplicationAttachment.js